import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "@/pages/Login";
import Deal from "@/pages/Deal";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminSubmissionDetail from "@/pages/AdminSubmissionDetail";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import Cookies from "@/pages/Cookies";
import BrowserCheck from "@/components/BrowserCheck";

function App() {
  return (
    <div className="App">
      <BrowserCheck />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="/deal" element={<Deal />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/submission/:id" element={<AdminSubmissionDetail />} />
          <Route path="/legal/privacy" element={<Privacy />} />
          <Route path="/legal/terms" element={<Terms />} />
          <Route path="/legal/cookies" element={<Cookies />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
